import React from 'react';

const PrivacyPage = () => {
  const styles = {
    container: {
      maxWidth: '800px',
      margin: '0 auto',
      padding: '40px 20px'
    },
    title: {
      fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
      color: '#1a1a2e',
      marginBottom: '10px'
    },
    date: {
      color: '#666',
      marginBottom: '30px'
    },
    section: {
      marginBottom: '30px'
    },
    heading: {
      fontSize: '1.3rem',
      color: '#1a1a2e',
      marginBottom: '15px'
    },
    text: {
      color: '#555',
      lineHeight: 1.7,
      marginBottom: '15px'
    },
    list: {
      color: '#555',
      lineHeight: 1.7,
      paddingLeft: '20px',
      marginBottom: '15px'
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Privacy Policy</h1>
      <p style={styles.date}>Last Updated: January 2026</p>

      <div style={styles.section}>
        <h2 style={styles.heading}>Information We Collect</h2>
        <p style={styles.text}>We collect information you provide directly, including:</p>
        <ul style={styles.list}>
          <li>Contact information (name, email, phone number)</li>
          <li>Location data (ZIP code for pharmacy searches)</li>
          <li>Drug search history</li>
          <li>Account preferences</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>How We Use Your Information</h2>
        <p style={styles.text}>We use collected information to:</p>
        <ul style={styles.list}>
          <li>Provide and improve our prescription discount services</li>
          <li>Find pharmacies near your location</li>
          <li>Send your digital discount card</li>
          <li>Send promotional emails (if you opt-in)</li>
          <li>Analyze usage patterns to improve our Service</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>Information Sharing</h2>
        <p style={styles.text}>
          We do not sell your personal information. We may share information with:
        </p>
        <ul style={styles.list}>
          <li>Service providers who assist in operating our platform</li>
          <li>Pharmacy partners to process discount cards</li>
          <li>Legal authorities when required by law</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>Data Security</h2>
        <p style={styles.text}>
          We implement appropriate security measures to protect your personal information. 
          However, no method of transmission over the Internet is 100% secure.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>Cookies</h2>
        <p style={styles.text}>
          We use cookies and similar technologies to enhance your experience, analyze traffic, 
          and personalize content. You can control cookie settings through your browser.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>Your Rights</h2>
        <p style={styles.text}>You have the right to:</p>
        <ul style={styles.list}>
          <li>Access your personal data</li>
          <li>Request correction of inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Opt-out of promotional communications</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>Children's Privacy</h2>
        <p style={styles.text}>
          Our Service is not intended for children under 13. We do not knowingly collect 
          information from children under 13.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>Contact Us</h2>
        <p style={styles.text}>
          For privacy-related questions or to exercise your rights, contact us at 
          privacy@chatwithdr.com.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPage;
